<app-navbar-primary />

<main class="bg-body-secondary">
  <div class="d-flex justify-content-center align-items-center h-100">
    <h4>Página no encontrada</h4>
  </div>
</main>

<app-footer-primary />
